/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOracleVirtualMachine = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 2H2v16h9v2H7v2h10v-2h-4v-2h9V2h-1zm1 14V4h16v12h-8zm11.728-8.929.772.429v5l-3.75 2.083L12 15l-.75-.417L7.5 12.5v-5l.772-.429L12 5zM12 6.716 9.817 7.929 12 9.142l2.183-1.213zM9 9.19v2.426l2.25 1.25V10.44zm3.75 3.676 2.25-1.25V9.191l-2.25 1.25z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOracleVirtualMachine as OracleVirtualMachine };
